<template>
  <div class="nav-list">
    <a href="#" class="nav-list__link" :class="{ 'nav-list__link--active': active === index }" v-for="(item, index) in itemList" :key="`contribution-${index}`" @click.prevent="onSelect(index)">
      {{ item }}
    </a>
  </div>
</template>

<script>
export default {
  props: {
    itemList: Array,
    active: Number
  },
  methods: {
    onSelect (index) {
      this.$emit('select', index)
    }
  }
}
</script>

<style lang="scss" scoped>
.nav-list {
  &__link {
    color: $theme-black;
    display: inline-block;
    font-weight: 600;
    letter-spacing: 1px;
    position: relative;
    white-space: nowrap;
    text-transform: uppercase;

    &:hover,
    &--active {
      @include make-active-item;

      color: $theme-black;
      text-decoration: none;
    }

    & + & {
      margin-left: 40px;
    }
  }
}
</style>
